import React, { FC } from 'react'

type Props = {
  className?: string
  size?: number
}

const FlagCrossCircle: FC<Props> = ({ className = '', size = 18 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="8" cy="8" r="6.15" stroke="#7C7899" strokeWidth="1.7" />
      <path d="M5.9 5.9L10.1 10.1" stroke="#7C7899" strokeWidth="1.35" strokeLinecap="round" />
      <path d="M10.1 5.9L5.9 10.1" stroke="#7C7899" strokeWidth="1.35" strokeLinecap="round" />
    </svg>
  )
}

export default FlagCrossCircle
